/* ============================================================
   Dates Dalah — behaviours v2
   Load once before </body> with defer.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('[data-dd-reveal]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-dd-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Rails (RTL safe) ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-dd-slider]').forEach(function (slider) {
      if (slider.dataset.ddReady === 'true') return;
      slider.dataset.ddReady = 'true';

      var track = slider.querySelector('[data-dd-track]');
      var prev = slider.querySelector('[data-dd-prev]');
      var next = slider.querySelector('[data-dd-next]');
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      /* In RTL, scrollLeft counts negative from 0 */
      function dir() { return getComputedStyle(track).direction === 'rtl' ? -1 : 1; }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var pos = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max;
        slider.classList.toggle('dd-slider--static', max <= 0);
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step() * dir(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step() * dir(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        clearTimeout(track._ddT);
        track._ddT = setTimeout(sync, 60);
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- Tab list (Essence section) ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-dd-tabs]').forEach(function (group) {
      if (group.dataset.ddReady === 'true') return;
      group.dataset.ddReady = 'true';

      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-dd-tab]'));
      var panels = group.querySelectorAll('[data-dd-panel]');

      function select(id) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-dd-tab') === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          t.classList.toggle('is-active', on);
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-dd-panel') !== id;
        });
      }

      group.addEventListener('click', function (e) {
        var t = e.target.closest('[data-dd-tab]');
        if (t) select(t.getAttribute('data-dd-tab'));
      });

      group.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var rtl = getComputedStyle(group).direction === 'rtl';
        var fwd = rtl ? 'ArrowLeft' : 'ArrowRight';
        var back = rtl ? 'ArrowRight' : 'ArrowLeft';
        var n = null;
        if (e.key === fwd || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        if (e.key === back || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        if (n === null) return;
        e.preventDefault();
        tabs[n].focus();
        select(tabs[n].getAttribute('data-dd-tab'));
      });

      if (tabs[0]) select(tabs[0].getAttribute('data-dd-tab'));
    });
  }

  /* ---------- Accordion (FAQ) — one open at a time ---------- */
  function initAccordion(root) {
    (root || document).querySelectorAll('[data-dd-accordion]').forEach(function (group) {
      if (group.dataset.ddReady === 'true') return;
      group.dataset.ddReady = 'true';
      var items = group.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (other) { if (other !== d) other.open = false; });
        });
      });
    });
  }

  /* ---------- Videos play only while visible ---------- */
  function initLazyVideo(root) {
    var vids = (root || document).querySelectorAll('video[data-dd-autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reduce) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot(root) {
    initReveal(root); initSliders(root); initTabs(root);
    initAccordion(root); initLazyVideo(root);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.DDTheme = { boot: boot };
})();
